<template>
  <div class="main-cn">
    <div class="main-hd">
      <h4>活动分享管理</h4>
    </div>
    <div class="main-bd mg20">
      <el-row class="searchSection">
        <el-form ref="filterForm" :inline="true" :model="filterForm">
          <el-form-item label="业务员姓名">
            <UserSelect ref="UserSelect" v-model="filterForm.salesman" @change="handleUserChange"></UserSelect>
          </el-form-item>
          <el-form-item label="用户名(不支持模糊搜索)">
            <el-input v-model="filterForm.referrername" placeholder="请输入用户名" size="small" />
          </el-form-item>
          <el-form-item label="产品类型">
            <el-select v-model="filterForm.product_id" placeholder="请选择" size="small">
              <el-option label="全部" value="" />
              <el-option v-for="(item, key) in productList" :key="key" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
          <el-form-item label="申请时间">
            <el-date-picker
              v-model="filterForm.dateRange"
              type="daterange"
              format="yyyy-MM-dd" 
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="small" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="small" @click="handleSearch">搜索</el-button>
            <el-button size="small" @click="handleReset">重置</el-button>
              <ExportFile
                          v-if="Acs('/sales-leads/share-manage-export')"
                          :url="'/api/sales-leads/share-manage-export'"
                          :params="filterForm"
                          filename="活动管理数据"
                          buttonName="导出Excel(最多导出10000条)">
              </ExportFile>

          </el-form-item>
        </el-form>
      </el-row>
      <el-table :data="tableData" style="width: 100%;" v-loading="loading" class="custom-table">
       <el-table-column prop="id" label="线索ID" width="300">
          <template #default="scope">
            <el-link 
              type="primary" 
              @click="handleIdClick(scope.row.id)"
              style="cursor: pointer;"
            >
              {{ scope.row.id }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column label="申请时间" width="300">
          <template slot-scope="scope">
            {{ formatTimestamp(scope.row.created_at) }}
          </template>
        </el-table-column>
        <el-table-column label="所在单位" width="300">
          <template slot-scope="scope">
            {{ scope.row.customer_name ? scope.row.customer_name : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="业务员" width="300">
          <template slot-scope="scope">
            {{ scope.row.users ? scope.row.users.name : '-' }}
          </template>
        </el-table-column>
        <el-table-column label="分享人" width="300">
          <template slot-scope="scope">
            {{ scope.row.referrer_name ? scope.row.referrer_name : '-' }}
          
          </template>
        </el-table-column>
        <el-table-column label="产品类型" width="300">
          <template slot-scope="scope">
            {{ getProductNames(scope.row.products) }}
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="linkPage">
        <pagination :linkPage="linkPage"></pagination>
      </el-row>
    </div>
  </div>
</template>

<script>
import Pagination from "~/widgets/Pagination.vue";
import ShareManageService from "~/services/ShareManage";
import ProductService from "~/services/product";
import UserSelect from "~/widgets/UserSelect.vue";
import ExportFile from "~/widgets/ExportFile.vue";

export default {
  name: 'ShareManage',
  components: {
    Pagination,
    UserSelect,
    ExportFile
  },
  data() {
    return {
      loading: false,
      filterForm: {
        salesman: '',
        referrername: '',
        product_id: '',
        dateRange: []
      },
      tableData: [],
      linkPage: null,
      productList: []
    }
  },
  // 监听路由参数更新执行分页请求
  beforeRouteUpdate: function (to, from, next) {
    let params = this.getParams();
    params['page'] = to.query["page"];
    params['perPage'] = to.query["perPage"];
    this.getList(params);
    next();
  },
  created() {
    this.getList(this.getParams());
    this.getProductList();
  },
  methods: {
      handleIdClick(id) {
      // 使用 Vue Router 进行跳转
      this.$router.push(`view?id=${id}&referer=%2Fsales-leads%2Findex`);
      
      // 或者使用原生方式跳转
      // window.location.href = `/#/sales-leads/view?id=${id}&referer=%2Fsales-leads%2Findex`;
    },
    // 时间戳转换为日期格式
    formatTimestamp(timestamp) {
      if (!timestamp) return '-';
      const date = new Date(timestamp * 1000); // 时间戳转毫秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 获取产品名称列表
    getProductNames(products) {
      if (!products || !Array.isArray(products) || products.length === 0) {
        return '-';
      }
      return products.map(product => product.product_name).join(', ');
    },
    // 获取产品列表
    getProductList() {
      ProductService.getOptionList().then(res => {
        if (res.code == 0) {
          this.productList = res.data;
        }
      })
    },
    // 获取查询参数
    getParams() {
      let params = {
        salesman: this.filterForm.salesman,
        referrername: this.filterForm.referrername,
        product_id: this.filterForm.product_id
      };
      
      if (this.filterForm.dateRange && this.filterForm.dateRange.length === 2) {
        params['apply_time[0]'] = this.filterForm.dateRange[0];
        params['apply_time[1]'] = this.filterForm.dateRange[1];
      }
      
      // 移除空值
      Object.keys(params).forEach(key => {
        if (!params[key]) delete params[key];
      });
      
      return params;
    },
    // 获取活动分享列表
    getList(params = {}) {
      this.loading = true;
      ShareManageService.getList(params).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.tableData = res.data;
          if (res._meta) {
            this.linkPage = res._meta;
          }
        } else {
          this.$message.error(res.message || '获取数据失败');
        }
      }).catch(err => {
        this.loading = false;
        this.$message.error('获取数据失败');
      });
    },
    // 搜索
    handleSearch() {
      this.getList(this.getParams());
    },
    // 重置
    handleReset() {
      this.filterForm = {
        salesman: '',
        referrername: '',
        product_id: '',
        dateRange: []
      };
      this.getList(this.getParams());
    },

    // 编辑操作
    handleEdit(row) {
      // 处理编辑逻辑
      console.log('编辑', row);
    },
    handleUserChange(item) {
      this.filterForm.salesman = item.value;
    }
  }
}
</script>

<style scoped>
.main-cn {
  height: 100%;
}
.searchSection {
  margin-bottom: 20px;
}

/* 自定义表格样式，去除竖线 */
.custom-table {
  border: 1px solid #e6e6e6;
}

.custom-table ::v-deep .el-table th,
.custom-table ::v-deep .el-table td {
  border-left: none !important;
  border-right: none !important;
}

.custom-table ::v-deep .el-table th:first-child,
.custom-table ::v-deep .el-table td:first-child {
  border-left: 1px solid #e6e6e6 !important;
}

.custom-table ::v-deep .el-table th:last-child,
.custom-table ::v-deep .el-table td:last-child {
  border-right: 1px solid #e6e6e6 !important;
}

.custom-table ::v-deep .el-table__header-wrapper {
  border-bottom: 1px solid #e6e6e6;
}

.custom-table ::v-deep .el-table__body-wrapper {
  border-top: none;
}
</style>


// WEBPACK FOOTER //
// src/views/clue/ShareManage.vue